<template>
  <div class="auth-promo-panel" :style="backgroundStyle">
    <div class="promo-content">
      <div class="hero-illustration">
        <img
          :src="imageSrc"
          :alt="$t('auth.promo.alt')"
          class="hero-image"
          @error="handleImageError"
        />
      </div>
      <div class="promo-text">
        <h2 class="promo-title">{{ $t('auth.promo.title') }}</h2>
        <p class="promo-subtitle">{{ $t('auth.promo.subtitle') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  asset?: string
}

const props = withDefaults(defineProps<Props>(), {
  asset: ''
})

// 默认使用 Doubao 生成的 Hero 图片
const defaultAsset = '/docs/wechat_login/hero_multi_docs.jpeg'

const imageSrc = computed(() => {
  return props.asset || defaultAsset
})

const backgroundStyle = computed(() => ({
  // 符合 PRD 品牌配色：科技蓝 (#4A90E2) + 青色 (#50E3C2)
  background: 'linear-gradient(135deg, #4A90E2 0%, #50E3C2 100%)'
}))

const handleImageError = (event: Event) => {
  // 如果图片加载失败，隐藏图片元素
  const img = event.target as HTMLImageElement
  if (img) {
    img.style.display = 'none'
  }
}
</script>

<style scoped lang="scss">
.auth-promo-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 40px 24px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(1px);
  }

  .promo-content {
    position: relative;
    z-index: 1;
    text-align: center;
    max-width: 320px;
  }

  .hero-illustration {
    margin-bottom: 24px;

    .hero-image {
      max-width: 100%;
      height: auto;
      border-radius: 12px;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
      transition: transform 0.3s ease;

      &:hover {
        transform: translateY(-4px);
      }
    }
  }

  .promo-text {
    .promo-title {
      font-size: 24px;
      font-weight: 700;
      color: white;
      margin: 0 0 12px 0;
      line-height: 1.3;
    }

    .promo-subtitle {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.9);
      margin: 0;
      line-height: 1.5;
      font-weight: 400;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .auth-promo-panel {
    min-height: 300px;
    padding: 32px 20px;

    .hero-illustration {
      margin-bottom: 20px;
    }

    .promo-text {
      .promo-title {
        font-size: 20px;
      }

      .promo-subtitle {
        font-size: 14px;
      }
    }
  }
}
</style>